module.exports = __webpack_public_path__ + "assets/bed.e231738e.svg";